
import { defineComponent, onMounted } from "vue";
import NavBar from "./components/NavBar.vue";
// import { Auth } from "aws-amplify";
import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: process.env
        .VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID as string,
      userPoolId: process.env.VUE_APP_AWS_USER_POOL_ID as string,
      loginWith: {
        oauth: {
          domain: process.env.VUE_APP_AWS_OAUTH_DOMAIN as string,
          scopes: ["email", "openid"],
          redirectSignIn: [
            process.env.VUE_APP_AWS_OAUTH_REDIRECT_SIGN_IN as string,
          ],
          redirectSignOut: [
            process.env.VUE_APP_AWS_OAUTH_REDIRECT_SIGN_OUT as string,
          ],
          responseType: "code",
        },
      },
    },
  },
});

export default defineComponent({
  name: "App",
  components: {
    NavBar,
  },
  data() {
    return {
      //
    };
  },
  setup() {
    //     const { initializeAuth } = useAuth();
    //     onMounted(() =>
    //       // initializeAuth({
    //       //   domain: process.env.VUE_APP_AUTH0_DOMAIN as string,
    //       //   client_id: process.env.VUE_APP_AUTH0_CLIENTID as string,
    //       //   audience: process.env.VUE_APP_AUTH0_AUDIENCE as string,
    //       //   scope: "openid profile email",
    //       // })
    //     );
  },
});
